import {
  INotification,
  IUserSpecifications,
} from "services/configuration/notifications/types";
import {
  DELIVERY_ERROR_STATUS_IDS,
  DELIVERY_STATUS_NOTIFICATION_TYPE_ID,
  normalizeDeliveryStatusIds,
} from "services/configuration/notifications/constants";

interface INotificationGrouped {
  [key: number]: {
    domain: string;
    domainId: number;
    notifications: INotification[];
  };
}

const getDeliveryStatusIds = (
  notificationTypeId: number,
  enabled: boolean,
  deliveryStatusIds?: Array<string | number> | null
) => {
  if (notificationTypeId !== DELIVERY_STATUS_NOTIFICATION_TYPE_ID) {
    return normalizeDeliveryStatusIds(deliveryStatusIds);
  }

  if (!enabled) {
    return deliveryStatusIds?.length
      ? normalizeDeliveryStatusIds(deliveryStatusIds)
      : null;
  }

  const normalizedIds = normalizeDeliveryStatusIds(deliveryStatusIds);

  if (normalizedIds.length) {
    return normalizedIds;
  }

  return [...DELIVERY_ERROR_STATUS_IDS];
};

export const userSpecificationQueryToForm = (
  userSpecifications: IUserSpecifications[]
): INotificationGrouped => {
  return userSpecifications.reduce<INotificationGrouped>((acc, spec) => {
    const {
      contentCategoryId,
      notificationTypeId,
      sendEmail,
      deliveryStatusIds,
    } = spec.specification;

    if (!acc[contentCategoryId]) {
      acc[contentCategoryId] = {
        domain: `Domain${contentCategoryId}`,
        domainId: contentCategoryId,
        notifications: [],
      };
    }

    acc[contentCategoryId].notifications.push({
      id: notificationTypeId,
      contentCategoryId,
      actionTypeId: notificationTypeId,
      isSelected: spec.enabled,
      sendEmail,
      deliveryStatusIds: getDeliveryStatusIds(
        notificationTypeId,
        spec.enabled,
        deliveryStatusIds
      ),
    });

    return acc;
  }, {});
};
